"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasCartesian2dUpdateArgProvider = void 0;
const cartesian2d_update_arg_1 = require("./cartesian2d-update-arg");
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Canvas implementation of {@link ICartesian2dUpdateArgProvider}, inverts the Y direction as canvas expects the origin
 * to be in the top left corner.
 */
class CanvasCartesian2dUpdateArgProvider {
    constructor() {
        this.reverseWholeRange = new rc_js_util_1.Range2d.f32();
        this.reverseInteractiveRange = new rc_js_util_1.Range2d.f32();
        this.updateArg = new cartesian2d_update_arg_1.Cartesian2dUpdateArg(Float64Array);
    }
    getUpdateArg(plot, canvasDims) {
        CanvasCartesian2dUpdateArgProvider.copyReverseY(this.reverseWholeRange, plot.plotDimensionsOTL.pixelArea.wholeRange);
        CanvasCartesian2dUpdateArgProvider.copyReverseY(this.reverseInteractiveRange, plot.plotDimensionsOTL.pixelArea.interactiveRange);
        this.updateArg.update(plot, canvasDims);
        this.updateArg.drawTransforms.update(this.updateArg.transformedDataRange, this.reverseWholeRange, this.reverseInteractiveRange);
        return this.updateArg;
    }
    static copyReverseY(to, from) {
        to[0] = from[0];
        to[1] = from[1];
        to[2] = from[3];
        to[3] = from[2];
    }
}
exports.CanvasCartesian2dUpdateArgProvider = CanvasCartesian2dUpdateArgProvider;
//# sourceMappingURL=canvas-cartesian2d-update-arg-provider.js.map